import { z } from 'zod';

export const wixConfigSchema = z.object({
  siteId: z.string().uuid(),
});
export type WixConfig = z.infer<typeof wixConfigSchema>;
